/**
 * @description entries editors can hide on French pages with "Hide on French pages" (`hideInFrench`). The content
 * types that have the field are listed in gatsbyHelpers/hideInFrench.js.
 */
export interface IHideableInFrench {
  hideInFrench?: boolean | null
}

/**
 * @description drops the entries marked "Hide on French pages" when the page is French. English pages keep them all.
 * Also tolerates a missing list, which the Preview API can return for an unset reference field.
 * @example filterHiddenInFrench([{ hideInFrench: true }, {}], true) => [{}]
 */
export const filterHiddenInFrench = <T extends IHideableInFrench>(
  entries: T[] | null | undefined,
  isFrench: boolean,
): T[] => (isFrench ? (entries ?? []).filter(entry => !entry?.hideInFrench) : entries ?? [])
